export default "__VITE_ASSET__Deco9h0h__"